module.exports = __webpack_public_path__ + "img/badge_eurete100.23fb8438.jpg";